<template>
  <li class="list-group-item kit-item" v-bind:class="className">
    <div class="row">

      <div class="col-lg-2 mb-3">
        <sampleStatus :kitStatus="status" :sampleStatus="kit.sampleStatus"/>
      </div>
      <div class="col-lg-7 details mb-3">
        <div >
          <h3 v-if="!kit.redeemedDate">Kit sent to <strong>{{kit.receiverEmail}}</strong></h3>
          <h3 v-else>Date redeemed: {{ dateString }}</h3>
          <h4>Kit ID: {{kit.kitId}}</h4>

        </div>
      </div>


      <div class="col-lg-3 col-12 mb-3 buttons" v-if="!kit.redeemedDate">
        <button class="btn btn-primary btn-send-again" v-on:click="onClickSend">Send again</button>
      </div>

    </div>
  </li>
</template>

<script>
import sampleStatus from '@/components/elements/sampleStatus'
import progressBar from '@/components/elements/progressBar'
import KitProgressBar from '@/components/elements/KitProgressBar'
import apiStringMappings from '@/mixins/apiStringMapping'
import moment from 'moment'

export default {
  name: 'SentKitItem',
  mixins: [apiStringMappings],
  components: {
    progressBar,
    sampleStatus,
    KitProgressBar
  },
  props: ['kit'],
  methods: {
    onClickSend: function () {
      this.$emit('onClickSend')
    }
  },
  computed: {
    status: function () {
      return (this.kit.redeemedDate) ? 'REDEEMED' : 'UNASSIGNED'
    },
    dateString: function () {
      if (this.kit.requestedDate == null) return 'Unknown purchase date'
      const theDate = moment(this.kit.requestedDate)// TODO: temp fix during bug in backend
      const month = theDate.format('MMMM')
      const day = theDate.format('D')
      return month + ' ' + day
    },
    className: function () {
      return (this.kit.kitStatus) ? this.kit.kitStatus.toLowerCase().replace(/_/g, '-') : ''
    },
    unlocked: function () {
      // Check all answerd / total questions. If > 100 return true
      if (this.kit.surveysStats == null) return false
      const total = this.kit.surveysStats.reduce((acc, el) => {
        const val = Number(el.totalQuestions)
        return acc + val
      }, 0)
      const completed = this.kit.surveysStats.reduce((acc, el) => {
        const val = Number(el.completedQuestions)
        return acc + val
      }, 0)
      return (completed / total * 100) >= 100
    },
    isUnassigned: function () {
      return this.kit.kitStatus === 'UNASSIGNED'
    }
  }
}
</script>

<style scoped lang='scss'>

  .list-group-item{
    padding-bottom: 0;
    min-height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/SentKitItem.vue